import type { ApiFilters, Filters } from './types';

export function getDefaults() : Filters {
  return {
    activityTypes: [],
    brokers: [],
    dateRange: {
      min: null,
      max: null,
    },
    page: 1,
    parentTypes: [],
    query: '',
  };
}

export function hasFilters(filters: Filters) {
  return (
    !!filters.activityTypes.length ||
    !!filters.brokers.length ||
    !!filters.dateRange.min ||
    !!filters.dateRange.max ||
    !!filters.parentTypes.length ||
    !!filters.query.trim().length
  );
}

export function serializeFilters(filters: Filters): ApiFilters {
  const apiFilters: ApiFilters = {
    activityTypeFilter: filters.activityTypes,
    broker: filters.brokers,
    page: filters.page,
    parentTypeFilter: filters.parentTypes,
    query: filters.query,
  };

  if (filters.dateRange.min) {
    apiFilters['date_range[gte]'] = filters.dateRange.min;
  }

  if (filters.dateRange.max) {
    apiFilters['date_range[lte]'] = filters.dateRange.max;
  }

  return apiFilters;
}
